import { ResultPrice } from 'models/auto/price';
import {
  RateUI,
  RATES_LABELS,
  RatesTypes,
  RATES_REQUIRED,
  RATES_ORDER,
  RATES_SIGNAL,
  RatesSignalTypes,
  RATES_CLASSES,
} from 'models/auto/vehicleRates';

export function mapPriceToRates(price: ResultPrice, priceAtDestination: number, total: number | null = null): RateUI[] {
  const rates: RateUI[] = [];

  let idx = Object.keys(RATES_LABELS).length;
  for (let key of Object.keys(RATES_LABELS)) {
    let value = 0;
    value = price[key] ? price[key] : 0;
    key = key === RatesTypes.Total && total ? RatesTypes.TotalPay : key;
    if (value !== 0 || RATES_REQUIRED[key]) {
      if (!(total && key === RatesTypes.Taxes)) {
        rates.push({
          className: getRateClass(key),
          id: key,
          value: value,
          label: RATES_LABELS[key] ? RATES_LABELS[key] : '',
          order: RATES_ORDER[key] ? RATES_ORDER[key] : idx++,
          signal: RATES_SIGNAL[key] ? RATES_SIGNAL[key] : RatesSignalTypes.NONE,
        });
      }
    }
  }

  if (total) {
    rates.push({
      className: getRateClass(RatesTypes.TotalPayNow),
      id: RatesTypes.TotalPayNow,
      value: total,
      label: RATES_LABELS[RatesTypes.TotalPayNow] ? RATES_LABELS[RatesTypes.TotalPayNow] : '',
      order: RATES_ORDER[RatesTypes.TotalPayNow] ? RATES_ORDER[RatesTypes.TotalPayNow] : idx++,
      signal: RATES_SIGNAL[RatesTypes.TotalPayNow] ? RATES_SIGNAL[RatesTypes.TotalPayNow] : RatesSignalTypes.NONE,
    });

    rates.push({
      className: getRateClass(RatesTypes.PaymentAgency),
      id: RatesTypes.PaymentAgency,
      value: price[RatesTypes.Taxes],
      label: RATES_LABELS[RatesTypes.PaymentAgency] ? RATES_LABELS[RatesTypes.PaymentAgency] : '',
      order: RATES_ORDER[RatesTypes.PaymentAgency] ? RATES_ORDER[RatesTypes.PaymentAgency] : idx++,
      signal: RATES_SIGNAL[RatesTypes.PaymentAgency] ? RATES_SIGNAL[RatesTypes.PaymentAgency] : RatesSignalTypes.NONE,
    });
  }

  if (priceAtDestination !== 0) {
    rates.push({
      className: getRateClass(RatesTypes.PaymentAgency),
      id: RatesTypes.PaymentAgency,
      value: priceAtDestination,
      label: RATES_LABELS[RatesTypes.PaymentAgency],
      order: RATES_ORDER[RatesTypes.PaymentAgency],
      signal: RATES_SIGNAL[RatesTypes.PaymentAgency],
    });
  }
  return rates.sort((a, b) => a.order - b.order);
}

function getRateClass(label: string): string {
  return RATES_CLASSES[label] ? RATES_CLASSES[label] : '';
}
